module.exports = __webpack_public_path__ + "static/media/logo.f9eb3e0a.svg";